import React from "react";

import { Box, Hint, LabelText, Row, Text } from "./styles";

interface CheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: React.ReactNode;
    hint?: React.ReactNode;
    disabled?: boolean;
    className?: string;
}

export const Checkbox = ({
    checked,
    onChange,
    label,
    hint,
    disabled,
    className,
}: CheckboxProps) => {
    const toggle = () => {
        if (disabled) return;
        onChange(!checked);
    };

    return (
        <Row className={className} $disabled={disabled}>
            <Box
                type="button"
                role="checkbox"
                aria-checked={checked}
                disabled={disabled}
                $checked={checked}
                onClick={toggle}
            >
                {checked && (
                    <svg width="12" height="10" viewBox="0 0 12 10" aria-hidden="true">
                        <path
                            d="M1 5.2 4.3 8.5 11 1.5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                )}
            </Box>
            <Text $disabled={disabled} onClick={toggle}>
                <LabelText>{label}</LabelText>
                {hint && <Hint>{hint}</Hint>}
            </Text>
        </Row>
    );
};
